import { Dialog, DialogContent, DialogTitle } from '@efexteam/components';
import { selectProfileData } from '@pages/profile/store/selectors';
import 'aiprise-web-sdk';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { AI_PRISE_ENV, TEMPLATE_IDS } from '../lifeProof.constants';
import { WebFrameProps } from './WebFrame.types';
import useWebFrame from './useWebFrame';

const WebFrame = ({ isOpen, onClose, sessionId }: WebFrameProps) => {
  const { watch } = useFormContext();
  const name = watch('name');
  const lastName = watch('lastName');

  const profile = useSelector(selectProfileData);
  const { isSubaccount } = profile || {};

  useWebFrame(isOpen, onClose);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle showCloseButton onClick={onClose} />
      <DialogContent className="h-[45em] w-full">
        <aiprise-frame
          mode={AI_PRISE_ENV}
          template-id={
            isSubaccount
              ? TEMPLATE_IDS[AI_PRISE_ENV].IS_SUBACCOUNT
              : TEMPLATE_IDS[AI_PRISE_ENV].IS_NOT_SUBACCOUNT
          }
          user-data={JSON.stringify({
            first_name: name,
            last_name: lastName,
          })}
          session-id={sessionId ?? ''}
        />
      </DialogContent>
    </Dialog>
  );
};

export default WebFrame;
